import { Routes } from '@/models/router/router.interface';
import { LoadingStatuses } from '@/models/loading.interface';
import store from '@/store';

export default class LoadForCampaignCreationCode {

	public mounted(): void {
		this.adjustSettingsBasedOnCampaignCreation();
		this.routeToGeneralPage();
	}

	private adjustSettingsBasedOnCampaignCreation(): void {
		store.mutations.setLoadingStatusPrimaryData(LoadingStatuses.INACTIVE);
		store.mutations.setLoadingStatusCampaignReadinessInfo(LoadingStatuses.INACTIVE);
		store.mutations.setIsCampaignCreation(true);
	}

	private routeToGeneralPage(): void {
		store.mutations.setCurrentRoute(Routes.GENERAL);
	}
}
